import React from 'react'
import { isAgentLogin, isCarrierLogin } from 'tools/auth'
import { REPORT_KEYS } from 'constants/reporting'
import ConsoleEmbed from 'components/ConsoleEmbed'
import { useEnsureInvitingCompanyId } from 'hooks/useEnsureInvitingCompanyId'

interface IRiskDecileProps {
  print?: boolean
  useCarrierFilters: boolean
}

const RiskDecileDashboard: React.FC<IRiskDecileProps> = (props) => {
  const { useCarrierFilters } = props
  const ensuredInvitingCompanyId = useEnsureInvitingCompanyId()

  const isAgentOrCarrier = isCarrierLogin() || isAgentLogin()
  const invitingCompanyId = isAgentOrCarrier
    ? ensuredInvitingCompanyId
    : undefined
  const carrierId =
    useCarrierFilters && !isCarrierLogin()
      ? localStorage.getItem('carrierId') || undefined
      : undefined
  return (
    <ConsoleEmbed
      reportKey={REPORT_KEYS.RISK_DECILE}
      invitingCompanyId={invitingCompanyId}
      carrierId={carrierId}
      fullHeight={!useCarrierFilters}
    />
  )
}
export default RiskDecileDashboard
